import { Injectable } from '@angular/core';

/**
 * No-op replacement for DebugConsoleService, swapped in for every deployed build configuration
 * (development, qa, staging, production) via Angular's `fileReplacements` in angular.json.
 * Substituting the whole file - rather than gating with a runtime environment flag - guarantees
 * the real implementation and its NGXS/MessageService/window.idxDebug wiring never end up in
 * those bundles, even for configurations that build unoptimized (e.g. development, staging),
 * where a runtime `if` check alone would not be dead-code-eliminated.
 * See IDX20-5812. Only the local/local-development/local-qa configs use the real
 * `debug-console.service.ts`.
 */
@Injectable({ providedIn: 'root' })
export class DebugConsoleService {
  public init(): void {}
}
